import { render, staticRenderFns } from "./ManageSchemaInput.vue?vue&type=template&id=a0058572&"
import script from "./ManageSchemaInput.vue?vue&type=script&lang=js&"
export * from "./ManageSchemaInput.vue?vue&type=script&lang=js&"
import style0 from "./ManageSchemaInput.vue?vue&type=style&index=0&id=a0058572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports